// src/pages/History/20thCentury/WorldWarIGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_World_War_I.png';

function HistoryPageWorldWarIGo() {
  return (
    <QuizPage
      title="History: World War I"
      subTopic="World War I"
      backgroundImage={historyImage}
      returnPath="/History-World-War-I"
    />
  );
}

export default HistoryPageWorldWarIGo;
